import HomeView from "./views/Home";
import HostessesView from "./views/Hostesses";
import ScheduleView from "./views/Schedule";
import RatesView from "./views/Rates";
import PromotionsView from "./views/Promotions";
import GalleryView from "./views/Gallery";
import ContactView from "./views/Contact";
import HiringView from "./views/Hiring";

export default [
    {
        path: "/home", name: "home", component: HomeView,
        meta: {
            icon: "mdi-waves"
        }
    },
    {
        path: "/hostesses", name: "hostesses", component: HostessesView,
        meta: {
            icon: "mdi-face-woman"
        }
    },
    {
        path: "/schedule", name: "schedule", component: ScheduleView,
        meta: {
            icon: "mdi-calendar-clock"
        }
    },
    {
        path: "/rates", name: "rates", component: RatesView,
        meta: {
            icon: "mdi-currency-usd"
        }
    },
    {
        path: "/promotions", name: "promotions", component: PromotionsView,
        meta: {
            icon: "mdi-percent"
        }
    },
    {
        path: "/gallery", name: "gallery", component: GalleryView,
        meta: {
            icon: "mdi-image"
        }
    },
    {
        path: "/hiring", name: "hiring", component: HiringView,
        meta: {
            icon: "mdi-clipboard-account-outline"
        }
    },
    {
        path: "/contact", name: "contact", component: ContactView,
        meta: {
            icon: "mdi-phone-message"
        }
    },
    { path: "*", component: HomeView },
];